export default function BrandBackground() {
  return (
    <div aria-hidden="true" data-testid="brand-background">
      <div className="bg-halo" />
      <div className="bg-grid" />
      <div className="bg-grain" />
      <div className="bg-vignette" />
    </div>
  );
}
